module.exports = __webpack_public_path__ + "ah1-e1e5aa3d80e308cc5797e73da8d7a17b.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/ah1.png
// module id = 8tYY
// module chunks = client